import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import { MasterKeyModel } from '../types/MasterKeyModel';

import { UserRole } from 'v2/constants';
import { Nullable } from 'v2/types';

export const userAtom = atom<Nullable<MasterKeyModel>>(null);
export const isUserAdminAtom = selectAtom<Nullable<MasterKeyModel>, boolean>(
  userAtom,
  (user) => !!user?.roles.includes(UserRole.ADMIN)
);

export const isUserHeadSupportAtom = selectAtom<Nullable<MasterKeyModel>, boolean>(
  userAtom,
  (user) => !!user?.roles.includes(UserRole.SUPPORT_ADMIN) && !user?.roles.includes(UserRole.ADMIN)
);

export const isUserSupportAtom = selectAtom<Nullable<MasterKeyModel>, boolean>(
  userAtom,
  (user) => !!user?.roles.includes(UserRole.SUPPORT) && !user?.roles.includes(UserRole.ADMIN)
);

export const isUserServiceAtom = selectAtom<Nullable<MasterKeyModel>, boolean>(
  userAtom,
  (user) =>
    !!user?.roles.includes(UserRole.SELLS_ADMIN) ||
    (!!user?.roles.includes(UserRole.SUPPORT_ADMIN) && !user?.roles.includes(UserRole.ADMIN))
);
